import { IVehicleFilterField } from '../types';

export const useProcessFilter = (
  filters: IVehicleFilterField[],
  conditionToDisable: boolean,
  conditionToHide: boolean,
  filterName: string,
): IVehicleFilterField[] => {
  if (conditionToHide) {
    return filters.filter((filter) => filter.name !== filterName);
  }

  const filterIndex = filters.findIndex((filter) => filter.name === filterName);

  if (filterIndex !== -1) {
    filters[filterIndex].controlProps!.disabled = conditionToDisable;

    return filters;
  }

  return filters;
};
